"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingEngineEnum = void 0;
var MeetingEngineEnum;
(function (MeetingEngineEnum) {
  MeetingEngineEnum[MeetingEngineEnum["voximplant_conference"] = 1] = "voximplant_conference";
  MeetingEngineEnum[MeetingEngineEnum["voximplant_peer2peer"] = 2] = "voximplant_peer2peer";
  MeetingEngineEnum[MeetingEngineEnum["voximplant_webinar"] = 3] = "voximplant_webinar";
  MeetingEngineEnum[MeetingEngineEnum["voximplant_stream"] = 4] = "voximplant_stream";
  MeetingEngineEnum[MeetingEngineEnum["tokbox"] = 5] = "tokbox";
  MeetingEngineEnum[MeetingEngineEnum["skype"] = 6] = "skype";
  MeetingEngineEnum[MeetingEngineEnum["hangouts"] = 7] = "hangouts";
  MeetingEngineEnum[MeetingEngineEnum["zoom"] = 8] = "zoom";
  MeetingEngineEnum[MeetingEngineEnum["teamviewer"] = 9] = "teamviewer";
})(MeetingEngineEnum = exports.MeetingEngineEnum || (exports.MeetingEngineEnum = {}));
